export function useCurrentStore(): number {
  const store = localStorage.getItem('store');
  return store === null ? 1 : Number(store);
}
